/*
 * Swaps the poster for the real player on click, so the page does not carry the
 * embed's weight for visitors who never press play.
 */
(function () {
  'use strict';

  function init(frame) {
    var button = frame.querySelector('[data-nb-video-play]');
    if (!button) return;

    button.addEventListener('click', function () {
      var src = frame.getAttribute('data-src');
      if (!src) return;

      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = frame.getAttribute('data-title') || 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;

      button.remove();
      frame.appendChild(iframe);
    }, { once: true });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-nb-video]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
